import { render } from "./HelpPage.vue?vue&type=template&id=3b1664c3"
import script from "./HelpPage.vue?vue&type=script&lang=js"
export * from "./HelpPage.vue?vue&type=script&lang=js"

import "./HelpPage.vue?vue&type=style&index=0&id=3b1664c3&lang=scss"
script.render = render

export default script